import { gql } from '@apollo/client'

// The card data for one leader, read straight off their own page under /leadership/.
// Kept as a fragment because the same set feeds two places: the grid on the leadership
// page and the slider at the foot of each individual profile.
//
// `sourceUrl(size: MEDIUM_LARGE)` rather than the shared FeaturedImageFragment, which
// asks for the full-size original — these render at 400px, and MEDIUM_LARGE is what the
// other card-sized images in this codebase request.
export const LeaderCardFieldsFragment = gql`
  fragment LeaderCardFields on Page {
    id
    title
    uri
    menuOrder
    featuredImage {
      node {
        altText
        sourceUrl(size: MEDIUM_LARGE)
      }
    }
    leaderFields {
      role
    }
  }
`
